import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {};

const getters = {};

const mutations = {};

const actions = {

    getCustCpe: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerid': payload
            }
            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/cpe' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                   
                    reject(error);
                });
        });
    },
    getCustProfile: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerid': payload
            }
            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/subscriberinfo' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getCustServices: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerid': payload
            }
            queryStr = makeQueryStringDync(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/services' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                    console.log("not reached")
                    reject(error);
                });
        });
    },
    getCustBill: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerid': payload
            }

            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/bill' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                  
                        resolve(data)
                    
                }).catch((error) => {
                   
                    console.log("not reached")
                    reject(error);
                });
        });
    },
    actGetTicket: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload)

            if (!queryStr) reject({ error: "query not found" })
            fetch(context.getters.baseUrl + '/lco/v1/ticket/mqticket' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                  
                        resolve(data)
                    
                }).catch((error) => {
                    console.log("not reached")
                    reject(error);
                });
        });
    },
    actCloseTicket: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let tickeid = payload.ticketid 
            delete payload.ticketid
            
            let data = makeQueryFormDataDyn(payload);
            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);
            fetch(context.getters.baseUrl + '/lco/v1/ticket/' + tickeid , {
                    method: 'PUT',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                    reject(error)
                });
        });
    },
    actGetLcoDetail: (context) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/lco', {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    
                        resolve(data)
                    
                }).catch((error) => {
                  
                    console.log("not reached");
                    reject(error);
                });
        });
    },
    actPostRefund: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/refund', {
                    method: 'POST',
                    body: payload
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                    console.log("not reached")
                    reject(error);
                });
        });
    },
    actFileUpload: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let data = makeQueryFormDataDyn(payload);

            fetch(context.getters.baseUrl + '/lco/v1/fileupload', {
                    method: 'POST',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actModifyCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/subscriber', {
                    method: 'POST',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                 
                        resolve(data)
                    
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetCategory: (context) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/ticket/category', {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                  
                        resolve(data)
                    
                }).catch((error) => {
                   
                    reject(error);
                });
        });
    },
    actPostTicket: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            let data = makeQueryFormDataDyn(payload);

            fetch(context.getters.baseUrl + '/lco/v1/ticket', {
                    method: 'POST',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getCustomerSelection: (context, payload) => {
        let queryStr = makeQueryStringDync(payload);
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/customerorder/offerplans' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    if (context.getters.getMode == "development") {
                        resolve();
                    } else {
                        resolve(data)
                    }
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    addReportQueue: (context, queueData) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/reports', {
                    method: 'POST',
                    body: queueData
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.text()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getProformInvoice: (context, filterData) => {
        return new Promise((resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)

            fetch(context.getters.baseUrl + '/lco/v1/invoice' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({
                            "count": "20",
                            "data": [{
                                    "idproforma_invoice": "9",
                                    "filename": "PRgHcWk1P0220219",
                                    "dphid": "RgHcWk1P",
                                    "created": "2021-02-09 18:34:20",
                                    "modified": null
                                },
                                {
                                    "idproforma_invoice": "8",
                                    "filename": "PRgHcWk1P0220218",
                                    "dphid": "RgHcWk1P",
                                    "created": "2021-02-09 18:27:36",
                                    "modified": null
                                },
                                {
                                    "idproforma_invoice": "7",
                                    "filename": "PRgHcWk1P0220217",
                                    "dphid": "RgHcWk1P",
                                    "created": "2021-02-09 18:07:32",
                                    "modified": null
                                }
                            ]
                        })
                    }
                    reject(error);
                });
        });
    },
    downloadProformInvoice: (context, payload) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/invoice/' + payload, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve('https://s3.ap-south-1.amazonaws.com/com.kyc.dpcollection.incablenet.mum/invoice/RgHcWk1P/PRgHcWk1P02202138.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAZTWJZDEUJKBH6SWE%2F20210211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20210211T105430Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1800&X-Amz-Signature=b8f1248dde00eb9ea5b3f2dfd714cead0dd345bcf6a0196688eff9d858fe78f1')
                        return
                    }
                    reject(error);
                });
        });
    },
    getInvoicePlans: (context, payload) => {
        let queryStr = makeQueryStringDync(payload);
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/plan.php' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve(
                            [{ "planid": "JWtNA2Kf", "planname": "&FLIX", "plantype": "CHANNEL", "plancode": "ALA0001PP", "servicecode": "[\"ALA0001CS\"]", "packagecode": null, "description": "&flix", "lcoprice": "13.50", "mrptariff": "15.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "n9lfJByC", "planname": "&PICTURES", "plantype": "CHANNEL", "plancode": "ALA0002PP", "servicecode": "[\"ALA0002CS\"]", "packagecode": null, "description": "&pictures", "lcoprice": "5.40", "mrptariff": "6.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "HDwdYiuq", "planname": "&TV", "plantype": "CHANNEL", "plancode": "ALA0003PP", "servicecode": "[\"ALA0003CS\"]", "packagecode": null, "description": "&TV", "lcoprice": "10.80", "mrptariff": "12.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "quiyzZ9Q", "planname": "1 SPORTS", "plantype": "CHANNEL", "plancode": "ALA0413PP", "servicecode": "[\"ALA0413CS\"]", "packagecode": "", "description": "1 Sports", "lcoprice": "3.60", "mrptariff": "4.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "eZdZvlwT", "planname": "24 GHANTA", "plantype": "CHANNEL", "plancode": "ALA0004PP", "servicecode": "[\"ALA0004CS\"]", "packagecode": null, "description": "24 Ghanta", "lcoprice": "0.09", "mrptariff": "0.10", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "DBMveBre", "planname": "AAJ TAK", "plantype": "CHANNEL", "plancode": "ALA0010PP", "servicecode": "[\"ALA0010CS\"]", "packagecode": null, "description": "AAJ TAK", "lcoprice": "0.68", "mrptariff": "0.75", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "1Ac7IMCW", "planname": "ADITHYA TV", "plantype": "CHANNEL", "plancode": "ALA0016PP", "servicecode": "[\"ALA0016CS\"]", "packagecode": null, "description": "Adithya TV", "lcoprice": "8.10", "mrptariff": "9.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "FqTU6LZ9", "planname": "ALANKAR", "plantype": "CHANNEL", "plancode": "ALA0017PP", "servicecode": "[\"ALA0017CS\"]", "packagecode": null, "description": "ALANKAR", "lcoprice": "3.60", "mrptariff": "4.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "qjOZN6KQ", "planname": "ANIMAL PLANET", "plantype": "CHANNEL", "plancode": "ALA0018PP", "servicecode": "[\"ALA0018CS\"]", "packagecode": null, "description": "Animal Planet", "lcoprice": "1.80", "mrptariff": "2.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "7CCDA0o9", "planname": "APNA EPIC VALUE", "plantype": "PACKAGE", "plancode": "BQEPIC44PP", "servicecode": "[\"BQEPIC044CS\"]", "packagecode": "", "description": "Apna Epic Value", "lcoprice": "1.80", "mrptariff": "2.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "3" }, { "planid": "lnaoTy1N", "planname": "ASIANET", "plantype": "CHANNEL", "plancode": "ALA0019PP", "servicecode": "[\"ALA0019CS\"]", "packagecode": null, "description": "Asianet", "lcoprice": "17.10", "mrptariff": "19.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "XYfSzm2e", "planname": "ASIANET MOVIES", "plantype": "CHANNEL", "plancode": "ALA0020PP", "servicecode": "[\"ALA0020CS\"]", "packagecode": null, "description": "Asianet Movies", "lcoprice": "13.50", "mrptariff": "15.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "NGw1VUkk", "planname": "ASIANET PLUS", "plantype": "CHANNEL", "plancode": "ALA0021PP", "servicecode": "[\"ALA0021CS\"]", "packagecode": null, "description": "Asianet Plus", "lcoprice": "4.50", "mrptariff": "5.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "c4MuWrbQ", "planname": "BBC WORLD NEWS", "plantype": "CHANNEL", "plancode": "ALA0023PP", "servicecode": "[\"ALA0023CS\"]", "packagecode": null, "description": "BBC WORLD NEWS", "lcoprice": "0.90", "mrptariff": "1.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "0.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NCF", "numchannels": "1" }, { "planid": "1nXYEDeG", "planname": "BENGALI PLUS", "plantype": "PACKAGE", "plancode": "INB0014PP", "servicecode": "[\"INB0014CS\"]", "packagecode": null, "description": "IN BANGALI PLUS", "lcoprice": "128.07", "mrptariff": "145.00", "tariffperiod": "1", "currency": "INR", "region": "MUM", "lcoregion": "MUM", "status": "ACTIVE", "planmode": "RENEWABLE", "tariffperiodtype": "M", "effectivedate": null, "newlcoprice": null, "newmrptariff": null, "ncfprice": "9.00", "discountedlcoprice": null, "renewperiod": "12", "hardwaretype": "ALL", "plancategory": "NORMAL", "numchannels": "61" }])
                    }
                    console.log("not reached");
                    reject(error);
                });
        });
    },
    getSTBCustomer: (context, payload) => {
        let queryStr = makeQueryStringDync(payload);
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/list-stb-subscribers' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({"count":"52","data":[{"city":"Mumbai","frcode":"FR5125","lco_name":"SHREE SAI CABLE VIDEO NETWORK","customer_can":"27138231","stb_number":"100132200289051","stb_type":"SD","status":"ACTIVE","base_pack":"Foundation + Hindi  Smart","validity":"1M","expiry_date":"19-AUG-22","last_dc_date":null,"firts_name":"Demo Life Time","last_name":".","mobile_no":"9036623729","stb_war_date": "26-JUN-23","lco_war_date": "06\/26\/2023"},{"city":"Mumbai","frcode":"FR5125","lco_name":"SHREE SAI CABLE VIDEO NETWORK","customer_can":"27358692","stb_number":"214121642530336","stb_type":"SD","status":"ACTIVE","base_pack":"Foundation Pack MH","validity":"3M","expiry_date":"05-OCT-22","last_dc_date":null,"firts_name":"FR5125(SHREE SAI CABLE VIDEO NETWORK)","last_name":"SWO","mobile_no":"9845198593","stb_war_date": "26-JUN-24","lco_war_date": "06\/02\/2024"}]})
                    }
                    console.log("not reached");
                    reject(error);
                });
        });
    },
    sendBroadbandDetails: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log('data ', payload);
            let data = makeQueryFormDataDyn(payload);

            fetch(context.getters.baseUrl + '/lco/v1/customer/broadbanddetails', {
                    method: 'POST',
                    body: data
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getHistory: (context, payload) => {
        let queryStr = makeQueryStringDync(payload);
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/subscriber/history' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({"count":"52","data":[{"date":"Mumbai","description":"FR5125 Recharge a payment of 125"},{"date":"Mumbai","description":"FR5125 Recharge a payment of 125"}, {"date":"Mumbai","description":"FR5125 Recharge a payment of 125"}]})
                    }
                    reject(error);
                });
        });
    },
    getCustomerType: (context) => {
        return new Promise((resolve, reject) => {

            fetch(context.getters.baseUrl + '/lco/v1/customer.php/type', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve([{"customerclass":"Customer","customertype":"Normal","customerclassid":"3","customertypeid":"21"}])
                        return
                    }
                    reject(error);
                });
        });
    },
    getTitle: (context) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/lco/title', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetPostal: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let dataObj = {};
            let queryStr = '';
            dataObj = {
                'postal_code': payload
            }
            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/lco/postalcode' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getHardwarepacks: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let dataObj = {};
            let queryStr = '';
            dataObj = {
                'customertypeid': payload.customertypeid,
                'postalcode': payload.postalcode,
                'customerclassid': payload.customerclassid
            }
            queryStr = makeQueryStringDync(dataObj);
            fetch(context.getters.baseUrl + '/lco/v1/product.php' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actPostCreateCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);

            fetch(context.getters.baseUrl + '/lco/v1/customer/createcustomer', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetDevice: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let queryStr = makeQueryStringDync(payload);
            fetch(context.getters.baseUrl + '/lco/v1/hardware/deviceavailibility' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getTotalPlanPrice: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let queryStr = ''
            queryStr = makeQueryStringDync(payload)
            if (!queryStr) reject({ error: "query not found" })
            fetch(context.getters.baseUrl + '/lco/v1/product/totalplanprice' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    // Advance renew pack
    getCustPacks: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let dataObj = {};
            let queryStr = ''
            dataObj = {
                'customerid': payload
            }
            queryStr = makeQueryStringDync(dataObj);

            fetch(context.getters.baseUrl + '/lco/v1/subscriber/services' + queryStr, {
                    method: 'GET'
                })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    // Bulk Customer
    postBulkCustomer: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/plan/createcustomer', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error)
                });
        });
    },
    getDisconnectedPlanList: (context, payload) => {
      return new Promise((resolve, reject) => {
        if (!payload) {
          reject({ error: "payload not found" });
        }
        let dataObj = {};
        let queryStr = ''
        dataObj = {
          'subscriberid': payload
        }
        queryStr = makeQueryStringDync(dataObj);
        fetch( context.getters.baseUrl + '/lco/v1/listdisconnectedplans' + queryStr, {
          method: 'GET'
        }) .then(errorServeiceHandler) .then((response) => {
          return response.json()
        }).then((data) => {
          resolve(data)
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // Bulk Customer Modify
    postBulkCustomerModify: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/plan/modifycustomer', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({"success":"1001506184"})
                    }
                    reject(error)
                });
        });
    }
};

export default { state, getters, mutations, actions };


// WEBPACK FOOTER //
// ./src/store/modules/customerModule.js